import { Tool } from "./interfaces";

export const databases = [
  {
    type: "database",
    name: "MongoDB",
    level: "Experienced",
    image: "mongodb.svg",
    tags: ["Database", "No-SQL", "Document", "Flexible"],
    experience: "+4 years",
    description: "",
  },
  {
    type: "database",
    name: "MySql",
    level: "Intermediate",
    image: "mysql.svg",
    tags: ["Database", "SQL", "Structured", "Flexible"],
    experience: "+5 years",
    description: "",
  },
  {
    type: "database",
    name: "Redis",
    level: "Intermediate",
    image: "redis.svg",
    tags: ["Database", "Unstructured", "fast", "Cash"],
    experience: "+2 years",
    description: "",
  },
  {
    type: "database",
    name: "Firestore",
    level: "Intermediate",
    image: "firebase.svg",
    tags: ["Database", "No-SQL", "Document", "FireStore"],
    experience: "+1 years",
    description: "",
  },
] as Array<Tool>;
